import { PluginEquifaxConsumerCreditReportRequest } from '../../../types/plugins';
import { ConstructPost } from '../../types/ConstructPost';
import { NonPaginatedResponse } from '../../types/NonPaginatedResponse';
import { PLUGIN_BASE_PATH } from '../constants/pluginBasePath';

export const runEquifaxApplyConsumerReportRequest = (
  constructPost: ConstructPost,
  data: PluginEquifaxConsumerCreditReportRequest,
): Promise<NonPaginatedResponse<null> | undefined> =>
  constructPost<NonPaginatedResponse<null>>(
    `${PLUGIN_BASE_PATH}/equifax-apply-consumer-report-request`,
    { data },
    { preventDefaultErrorToast: true },
  );
